/*
 * Z-Stack offer page: cart-aware buy box (Shopify only). Copied to assets/zso-cart.js by build-zso.py.
 *
 * - The store's cart is Recharge's drawer. It opens with RechargePubSub.publish('cart-drawer:open').
 * - If the $4.95 offer is already in the cart, Buy Now becomes "View cart" and shows the chosen gift
 *   with a "Change gift" link (reopens the dev's gift picker; its "+ Add" replaces the existing offer line).
 * - If the one-time bottle is already in the cart, "Buy once" becomes "View cart" instead of adding another.
 * - One or the other: adding the offer removes one-time bottles from the cart, and vice versa.
 * - The cart is re-read on load, on back/forward (pageshow), when the tab regains focus and on Recharge cart events.
 */
(function () {
  var zso = document.getElementById('zso');
  var cfgEl = document.querySelector('script[data-zgift-config]');
  if (!zso || !cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var form = zso.querySelector('.zso-form');
  var buyNow = form && form.querySelector('[type=submit]');
  var once = zso.querySelector('a[href="#zgift-onetime"]');
  var offerNote = zso.querySelector('[data-zso-incart-offer]');
  var onceNote = zso.querySelector('[data-zso-incart-once]');
  var giftName = zso.querySelector('[data-zso-gift-name]');
  var labels = { buyNow: buyNow && buyNow.textContent, once: once && once.textContent };
  var state = { offer: null, once: null };
  var reconciling = false;
  var quietUntil = 0; // Recharge re-publishes cart events for every /cart request, ours included
  var syncTimer = null;

  function isOffer(line) { return line.product_id === CFG.productId; }
  function isOnce(line) { return CFG.oneTimeVariant && line.variant_id === CFG.oneTimeVariant; }

  function getCart() {
    quietUntil = Date.now() + 1500;
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function change(key, qty) {
    quietUntil = Date.now() + 1500;
    return fetch(root + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  function openCart() {
    try { if (window.RechargePubSub) { RechargePubSub.publish('cart-drawer:open'); return; } } catch (e) {}
    window.location = root + 'cart';
  }

  function render() {
    var offer = state.offer, one = state.once;
    if (buyNow) buyNow.textContent = offer ? 'View cart' : labels.buyNow;
    if (offerNote) offerNote.hidden = !offer;
    if (giftName && offer) giftName.textContent = offer.variant_title || 'Your gift';
    if (once) once.textContent = one ? 'View cart' : labels.once;
    if (onceNote) onceNote.hidden = !one;
    zso.classList.toggle('zso-has-offer', !!offer);
    zso.classList.toggle('zso-has-once', !!one);
    if (window.zsoLockBuy) window.zsoLockBuy(); // in-cart notes change the buy box height
  }

  function sync() {
    return getCart().then(function (cart) {
      var items = cart.items || [];
      state.offer = items.filter(isOffer)[0] || null;
      state.once = items.filter(isOnce)[0] || null;
      render();
      return cart;
    }).catch(function () {});
  }

  // One or the other: after an add, drop the other kind of line.
  function reconcile(added) {
    if (reconciling || !added) return;
    var keepOffer = added.product_id === CFG.productId;
    var keepOnce = CFG.oneTimeVariant && (added.variant_id === CFG.oneTimeVariant || added.id === CFG.oneTimeVariant);
    if (!keepOffer && !keepOnce) { sync(); return; }
    reconciling = true;
    getCart().then(function (cart) {
      var drop = (cart.items || []).filter(function (l) { return keepOffer ? isOnce(l) : isOffer(l); });
      return drop.reduce(function (p, l) { return p.then(function () { return change(l.key, 0); }); }, Promise.resolve())
        .then(function () {
          if (drop.length) { try { RechargePubSub.publish('cart:refresh'); } catch (e) {} }
        });
    }).catch(function () {}).then(function () { reconciling = false; sync(); });
  }

  // Runs before the dev's capture-phase submit/click handlers (those are on document).
  // Re-check the cart at tap time: the shopper may have removed the item inside Recharge's cart.
  window.addEventListener('submit', function (e) {
    if (e.target !== form || !state.offer) return;
    e.preventDefault(); e.stopImmediatePropagation();
    sync().then(function () {
      if (state.offer) openCart();
      else if (form.requestSubmit) form.requestSubmit(buyNow); // now goes to the gift picker
    });
  }, true);

  window.addEventListener('click', function (e) {
    var t = e.target;
    if (once && t.closest && t.closest('a[href="#zgift-onetime"]') === once && state.once) {
      e.preventDefault(); e.stopImmediatePropagation();
      sync().then(function () {
        if (state.once) openCart();
        else once.click(); // now adds the one-time bottle
      });
      return;
    }
    if (t.closest && t.closest('[data-zso-change-gift]')) {
      e.preventDefault();
      var d = document.querySelector('[data-zgift-drawer]');
      if (!d) return;
      var err = d.querySelector('[data-zgift-error]'); if (err) err.hidden = true;
      d.querySelectorAll('[data-zgift-add]').forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); });
      d.hidden = false;
      document.documentElement.classList.add('zgift-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
      var panel = d.querySelector('.zgift-drawer__panel'); if (panel) panel.focus();
    }
  }, true);

  function soon() {
    if (reconciling || Date.now() < quietUntil) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 300);
  }

  function hookRecharge() {
    if (!window.RechargePubSub || hookRecharge.done) return !!hookRecharge.done;
    hookRecharge.done = true;
    // Only item-level events: cart:update / cart:refresh fire for every cart request and would loop.
    RechargePubSub.subscribe('cart:item:add', function (p) {
      var item = p && p.item;
      setTimeout(function () { reconcile(item); }, 150);
    });
    RechargePubSub.subscribe('cart:item:update', soon);
    // Removing in Recharge's cart only fires cart:update; soon() ignores the ones our own requests cause.
    RechargePubSub.subscribe('cart:update', soon);
    return true;
  }
  if (!hookRecharge()) {
    var tries = 0, t = setInterval(function () { if (hookRecharge() || ++tries > 40) clearInterval(t); }, 250);
  }

  window.addEventListener('pageshow', function () { sync(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') sync(); });
  sync();
})();
